<script setup>
  import { computed, ref } from 'vue'
  import FlyoutMobileSubmenu from '@/components/Ui/FlyoutMobileSubmenu.vue'

  const activeChildren = ref(undefined)
  const submenuActive = ref(false)

  const props = defineProps({
    open: Boolean,
    items: Object,
    smallItems: Object
  })

  const menuTopItems = computed(() => {
    let mergedItems = []
    mergedItems.push(...props.items, ...props.smallItems)
    return mergedItems
  })

  const setSubmenu = (item) => {
    submenuActive.value = !submenuActive.value

    if (submenuActive.value) {
      activeChildren.value = item.children
    }
  }

  const resetSubmenu = () => {
    submenuActive.value = false
    activeChildren.value = undefined
  }

</script>

<template>
  <div
    class="flyout-mobile-wrapper relative"
  >
    <ul
      class="flyoute-menu-top-level"
    >
      <li
        v-for="(item, index) in menuTopItems"
        :key="index"
        class="menu-item-top pl-6 font-light flex flex-row items-center justify-between border-b first:border-t !border-white/30"
      >
        <a
          class="!text-white py-5 text-xl"
          :href="item.url"
        >
          {{ item.title }}
        </a>
        <button
          v-if="item.children"
          class="flex flex-row items-center border-x !border-white/30 px-3 py-5"
          @click="setSubmenu(item)"
        >
          <AppIcon
            class="!bg-transparent"
            name="Chevron"
          />
        </button>
      </li>
    </ul>
    <FlyoutMobileSubmenu
      :items="activeChildren"
      :open="submenuActive"
      @resetSubmenu="resetSubmenu"
    />
  </div>
</template>

<style lang="scss" scoped>
.menu-item-top :deep(svg) {
  @apply h-4 -rotate-90;
}
.menu-item-top :deep(svg path) {
  fill: #fff !important;
}
</style>
